import 'edge/quoteandbind/quickquote/common/app';
import 'edge/addresslookup/app';
import SupportedLobModules from 'integration/quoteandbind/quickquote/SupportedLobModules';

SupportedLobModules.push('edge.quoteandbind.quickquote.common.app');
SupportedLobModules.push('edge.addresslookup.app');

export default angular.module('edge.quoteandbind.quickquote.app', SupportedLobModules);
